import * as React from 'react';
import { styled } from '@mui/material/styles';
import Divider, { dividerClasses } from '@mui/material/Divider';
import Menu from '@mui/material/Menu';
import MuiMenuItem from '@mui/material/MenuItem';
import { paperClasses } from '@mui/material/Paper';
import { listClasses } from '@mui/material/List';
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded';
import MenuButton from './MenuButton';
import DeleteIcon from '@mui/icons-material/Delete';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';





const MenuItem = styled(MuiMenuItem)({
  margin: '2px 0',
});

export default function ChatItemOptionsMenu( { thread, handleDelete, handleRename, handleFreeze }) {
  const [ anchorEl, setAnchorEl ] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <React.Fragment>
        <MenuButton
        aria-label="Open menu"
        onClick={handleClick}
        sx={{ borderColor: 'transparent', right: '10px' }}
      >
        <MoreVertRoundedIcon sx={{ color: 'white' }} />
      </MenuButton>
      <Menu
        dense
        anchorEl={anchorEl}
        id="menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        sx={{
          [`& .${listClasses.root}`]: {
            padding: '8px'
          },
          [`& .${paperClasses.root}`]: {
            padding: 0,
          },
          [`& .${dividerClasses.root}`]: {
            margin: '4px -4px',
          },
        }}
      >
        {/* <FormControlLabel control={<Checkbox defaultChecked checked={thread.metadata?.freeze_name==='true'? false : true} onChange={(value) => handleFreeze(thread, value)} />} label="Auto rename" /> */}
        {/* <MenuItem onClick={() => handleRename(thread)} sx={{
            color: 'white', 
            padding: 'unset', 
            display: 'flex', 
            justifyContent: 'space-evenly'}}
            >
            <DriveFileRenameOutlineIcon sx={{ marginRight: '5px' }} />Rename
        </MenuItem>  */}
        
        {/* <Divider /> */}
        {/* <MenuItem onClick={handleClose}>Add another account</MenuItem> */}
        <MenuItem onClick={() => handleDelete(thread)} sx={{
            color: 'red', 
            padding: 'unset', 
            display: 'flex', 
            justifyContent: 'space-evenly'}}
            >
            <DeleteIcon />Delete
        </MenuItem> 

        
      </Menu>
    </React.Fragment>
  );
}